// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgencyAssignmentController from "./agency_assignment_controller"
application.register("agency-assignment", AgencyAssignmentController)

import AgentAssignmentController from "./agent_assignment_controller"
application.register("agent-assignment", AgentAssignmentController)

import GlobalShortcutsController from "./global_shortcuts_controller"
application.register("global-shortcuts", GlobalShortcutsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import JobStatusController from "./job_status_controller"
application.register("job-status", JobStatusController)

import ListController from "./list_controller"
application.register("list", ListController)

import ListShortcutsController from "./list_shortcuts_controller"
application.register("list-shortcuts", ListShortcutsController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import RoleController from "./role_controller"
application.register("role", RoleController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import EntryTimestampController from "./entry_timestamp_controller"
application.register("entry-timestamp", EntryTimestampController)

import QuickSubmitController from "./quick_submit_controller"
application.register("quick-submit", QuickSubmitController)

import ClearFieldController from "./clear_field_controller"
application.register("clear-field", ClearFieldController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
